export const categories = [
  { slug: 'football', name: '足球', icon: 'ri-football-line', color: 'primary', description: '英超、西甲、意甲、德甲、法甲等欧洲五大联赛及世界杯赛事资讯' },
  { slug: 'basketball', name: '篮球', icon: 'ri-basketball-line', color: 'accent', description: 'NBA、CBA、欧洲篮球联赛等全球顶级篮球赛事动态' },
  { slug: 'tennis', name: '网球', icon: 'ri-award-line', color: 'secondary', description: '四大满贯、ATP、WTA巡回赛最新赛果与分析' },
  { slug: 'esports', name: '电竞', icon: 'ri-gamepad-line', color: 'primary', description: 'LOL、DOTA2、CS:GO等热门电竞项目赛事直播与战报' },
  { slug: 'racing', name: '赛车', icon: 'ri-steering-line', color: 'accent', description: 'F1方程式、MotoGP、WRC等顶级赛车运动赛事追踪' },
  { slug: 'other', name: '综合', icon: 'ri-medal-line', color: 'secondary', description: '乒乓球、羽毛球、游泳、田径等综合体育项目资讯' },
];

export const categoryColors: Record<string, { bg: string; text: string; bar: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', bar: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', bar: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', bar: 'bg-secondary-500' },
};